import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { AU_DESKTOP_EVENTS } from "../../../tracking/au.desktop-events";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import CommingSoonDetail from "../comming-soon-detail-image";
import { getCarDetailsGalleryPageURL } from "../../../utils/helpers/get-detail-page-url";
import { useHistory } from "react-router-dom";
import { GALLERY_TAB_TYPE, MEDIA_SOURCE, NUMBER } from "../../../constants/app-constants";
import HeroSliderCdpRevamp from "../hero-slider-cdp-revamp";

const CarDetailOuterImagesRevamp = ({
    content,
    setGsGalleryDataConnect,
    onWishlistClick,
    isWishlisted,
    showWishListIcon
}) => {
    const {
        comingSoon,
        mediaSource,
        threeSixtyViewUrl
    } = content;

    const history = useHistory();

    const onClickImage = (activeTab = "", imageIndex = 0) => {
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CAR_DETAILS_IMAGE_GALLERY_VIEW, {
            eventLabel: `Section selected ${activeTab}`
        });

        if (mediaSource === MEDIA_SOURCE.helloAR) {
            const params = {
                selectedImageIndex: NUMBER.ZERO,
                activeTab: threeSixtyViewUrl ? GALLERY_TAB_TYPE.threeSixtyViewUrl : activeTab,
                subActiveTab: activeTab,
                isOpen: true
            };
            setGsGalleryDataConnect(params);
            const url = getCarDetailsGalleryPageURL({
                content,
                activeTab: params.activeTab,
                subActiveTab: params.subActiveTab,
                selectedImageIndex: NUMBER.ZERO,
                mediaSource
            });
            history.push(url);
        } else {
            const url = getCarDetailsGalleryPageURL({content, activeTab, selectedImageIndex: imageIndex });
            history.push(url);
        }
    };

    // const ViewComponent = mediaSource === MEDIA_SOURCE.s20 ? HeroSliderRevamp : HeroSliderCdpRevamp;
    const ViewComponent = HeroSliderCdpRevamp;
    // const ViewComponent = mediaSource === MEDIA_SOURCE.s20 ? HeroSliderRevamp : HeroSlider;

    return (
        <div>
            <div styleName={"styles.containerBackground"}>
                {comingSoon ?
                    <CommingSoonDetail bodyType={content.body || content.bodyType} fullScreenGallery={true}/>
                    :
                    <ViewComponent
                        openGalleryPopUp={onClickImage}
                        onWishlistClick={onWishlistClick}
                        isWishlisted={isWishlisted}
                        showWishListIcon={showWishListIcon}
                    />
                }
            </div>
        </div>
    );
};

CarDetailOuterImagesRevamp.propTypes = {
    content: PropTypes.object,
    setGsGalleryDataConnect: PropTypes.func,
    onWishlistClick: PropTypes.func,
    isWishlisted: PropTypes.bool,
    showWishListIcon: PropTypes.bool
};

export default CarDetailOuterImagesRevamp;
